import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51012c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "syncPersonRowFun" }
const _hoisted_2 = { class: "button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下发至所有设备")
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备名称：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否下发成功：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原因：", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("下发")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-top":"10px"} }, "没有更多了", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _ctx.refresh,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_van_button, {
        type: "success",
        onClick: _ctx.syncAll,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list",
              style: _normalizeStyle({ marginTop: index === 0 ? '5px' : '15px' }),
              key: index
            }, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(item.deviceName), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(item.result === 0 ? "失败" : "成功"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(item.reason), 1)
              ]),
              _createVNode(_component_van_button, {
                class: "xiafa",
                size: "small",
                plain: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.syncOne(item))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 4))
          }), 128)),
          _hoisted_11
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ]))
}